<template>
    <button type="button" :class="{'bg-pink':selected}" class="label-select">
        {{ title }}
    </button>
</template>

<script>
export default {
    name: "AtomLabelSelect",
    props: {
        title: {
            type: String,
            default: ""
        },
        selected: {
            type: Boolean,
            default: false
        },
    },
}
</script>

<style scoped>
.label-select{
    @apply text-white border border-white border-opacity-10 px-6 py-2 rounded-full md:hover:bg-pink
    transition ease-in-out duration-200 hover:cursor-pointer select-none;
}
</style>
